"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TestimonialSectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/users/user-lg-6.jpg" | "/Templates/Doccure/img/users/user-lg-1.jpg" | "/Templates/Doccure/img/users/user-lg-2.jpg" | "/Templates/Doccure/img/users/user-lg-3.jpg" */
    src: string;
    /** Detected variants: "Femina Adrian" | "James Rodriguez" | "Margaret Chen" */
    a0Text: ReactNode;
    /** Detected variants: "ACL Surgery Recovery" | "Chronic Back Pain" | "Hip Replacement Recovery" */
    p0Text: ReactNode;
    /** Detected variants: "After my ACL reconstruction, I was worried I'd never get back to running. The team here created a personalized recovery plan that had me running 5Ks again in just 4 months." | "I lived with chronic lower back pain for over 3 years. Within 6 weeks of starting treatment, I was pain-free for the first time in years. The manual therapy and exercises they taught life-changing." | "At 68, I wasn't sure how my recovery would go after hip replacement surgery. The staff here were patient, professional, and incredibly skilled." */
    p0P0Text: ReactNode;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "testimonial-item-eighteen" */
    div0ClassName?: string;
    /** Detected variants: "author-img" */
    a0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "user" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "testimonial-author" */
    div0ClassName2?: string;
    /** Detected variants: "testimonial-content" */
    div1ClassName?: string;
    /** Detected variants: "author-name" */
    div0ClassName3?: string;
    /** Detected variants: "#" */
    a0Href?: string;
    /** Detected variants: "name" */
    h30ClassName?: string;
    /** Detected variants: "roll" */
    p0ClassName?: string;
    /** Detected variants: "testimonial" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid icon" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "/Templates/Doccure/img/icons/testimonial-icon-2.svg" */
    imageWithBasePath0Src?: string;
    /** Detected variants: "description" */
    p0ClassName2?: string;
};
export type HomeEighteenTestimonialSectionGeneratedProps = {
    divDiv0Div0A0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionSlidesItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "Real Stories, Real Resultsy" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Helped Patients To" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    /** Default: "Reclaim Lives" */
    sectionDiv0Div0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "title" */
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/title-img-4.jpg" */
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "testimonial-img" */
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/testimonial-img-1.png" */
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "testimonial-img" */
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/testimonial-shadow-1.png" */
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "up" */
    sectionDiv0Div0Div1Div0DivDataDirection?: string;
    /** Default: "fast" */
    sectionDiv0Div0Div1Div0DivDataSpeed?: string;
    /** Default: "testimonial-shadow" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/testimonial-shadow-2.png" */
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    testimonialSectionSlides: TestimonialSectionSlidesItem[];
    testimonialSectionSlidesItemWrapper?: (item: TestimonialSectionSlidesItem, content: ReactNode) => ReactNode;
    testimonialSectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidesImageVisible?: boolean;
    testimonialSectionSlidesImageRenderer?: (item: TestimonialSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidesH3Visible?: boolean;
    testimonialSectionSlidesH3Renderer?: (item: TestimonialSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionSlidesItem) => Partial<ComponentProps<"h3">>);
};

const HomeEighteenTestimonialSectionGenerated: FC<HomeEighteenTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0DivText = "Real Stories, Real Resultsy",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H20H2Text = "Helped Patients To",
    sectionDiv0Div0Div0Div0H20H2Text2 = "Reclaim Lives",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageAlt = "title",
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/title-img-4.jpg",
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageAlt = "testimonial-img",
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/testimonial-img-1.png",
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageAlt = "testimonial-img",
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/testimonial-shadow-1.png",
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div0Div1ImageWithBasePath1ImageProps,
    sectionDiv0Div0Div1Div0DivDataDirection = "up",
    sectionDiv0Div0Div1Div0DivDataSpeed = "fast",
    sectionDiv0Div0Div1ImageWithBasePath0ImageAlt = "testimonial-shadow",
    sectionDiv0Div0Div1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/testimonial-shadow-2.png",
    sectionDiv0Div0Div1ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1ImageWithBasePath0ImageProps,
    divDiv0Div0A0ImageWithBasePath0ImageProps,
    divDiv0Div1Div0H30H3Props,
    divDiv0Div1ImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    testimonialSectionSlides,
    testimonialSectionSlidesItemWrapper,
    testimonialSectionSlidesRenderer,
    testimonialSectionSlidesImageVisible,
    testimonialSectionSlidesImageRenderer,
    testimonialSectionSlidesH3Visible,
    testimonialSectionSlidesH3Renderer,
    testimonialSectionSlidesImageProps,
    testimonialSectionSlidesH3Props,
}) => {
    return (
        <section className="section testimonial-section-eighteen">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row"}>
                    <div className="col-lg-5">
                        <div className="section-header-eighteen text-lg-start wow fadeInDown" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            <div className="sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                            {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H20H2Text}
                                    <br />
                                    <span className="title-img">
                                        {renderNode(sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </span>
                                    {sectionDiv0Div0Div0Div0H20H2Text2}
                                </h2>
                            ))}
                        </div>
                        <div className="testimonial-img-eighteen">
                            {renderNode(sectionDiv0Div0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div1ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid img-one" {...(sectionDiv0Div0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div0Div1ImageWithBasePath1ImageVisible, sectionDiv0Div0Div0Div1ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div0Div1ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div0Div1ImageWithBasePath1ImageAlt} className="img-fluid img-two" {...(sectionDiv0Div0Div0Div1ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-7 position-relative">
                        <div className="vertical-slide slide-eighteen two d-flex" data-direction={sectionDiv0Div0Div1Div0DivDataDirection} data-speed={sectionDiv0Div0Div1Div0DivDataSpeed}>
                            <div className="slide-list d-flex gap-4">
                                {renderCollectionNode(
                                    testimonialSectionSlides,
                                    (item: TestimonialSectionSlidesItem) => (
                                        <div className={item.className ?? "slide-item"} key={item.key}>
                                            <div className={item.div0ClassName ?? "testimonial-item-eighteen"}>
                                                <div className={item.div0ClassName2 ?? "testimonial-author"}>
                                                    <a href={item.href ?? "#"} className={item.a0ClassName ?? "author-img"}>
                                                        {renderItemNode(testimonialSectionSlidesImageVisible, testimonialSectionSlidesImageRenderer, item, (
                                                            <SmartImage src={item.src} alt={item.alt ?? "user"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof testimonialSectionSlidesImageProps === "function" ? testimonialSectionSlidesImageProps(item) : (testimonialSectionSlidesImageProps ?? {}))} {...(typeof divDiv0Div0A0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0A0ImageWithBasePath0ImageProps(item) : (divDiv0Div0A0ImageWithBasePath0ImageProps ?? {}))} />
                                                        ))}
                                                    </a>
                                                </div>
                                                <div className={item.div1ClassName ?? "testimonial-content"}>
                                                    {renderItemNode(testimonialSectionSlidesImageVisible, testimonialSectionSlidesImageRenderer, item, (
                                                        <SmartImage src={item.imageWithBasePath0Src ?? "/Templates/Doccure/img/icons/testimonial-icon-2.svg"} alt={item.imageWithBasePath0Alt ?? "testimonial"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid icon"} {...(typeof testimonialSectionSlidesImageProps === "function" ? testimonialSectionSlidesImageProps(item) : (testimonialSectionSlidesImageProps ?? {}))} {...(typeof divDiv0Div1ImageWithBasePath0ImageProps === "function" ? divDiv0Div1ImageWithBasePath0ImageProps(item) : (divDiv0Div1ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                    <p className={item.p0ClassName2 ?? "description"}>{item.p0P0Text}</p>
                                                    <div className={item.div0ClassName3 ?? "author-name"}>
                                                        {renderItemNode(testimonialSectionSlidesH3Visible, testimonialSectionSlidesH3Renderer, item, (
                                                            <h3 className={item.h30ClassName ?? "name"} {...(typeof testimonialSectionSlidesH3Props === "function" ? testimonialSectionSlidesH3Props(item) : (testimonialSectionSlidesH3Props ?? {}))} {...(typeof divDiv0Div1Div0H30H3Props === "function" ? divDiv0Div1Div0H30H3Props(item) : (divDiv0Div1Div0H30H3Props ?? {}))}>
                                                                <a href={item.a0Href ?? "#"}>{item.a0Text}</a>
                                                            </h3>
                                                        ))}
                                                        <p className={item.p0ClassName ?? "roll"}>{item.p0Text}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ),
                                    testimonialSectionSlidesItemWrapper,
                                    testimonialSectionSlidesRenderer
                                )}
                            </div>
                        </div>
                        {renderNode(sectionDiv0Div0Div1ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div1ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div1ImageWithBasePath0ImageAlt} className="img-fluid shaow-one" {...(sectionDiv0Div0Div1ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HomeEighteenTestimonialSectionGenerated;
